import { CURRENT_GAME_KEY, DEFAULT_GAMES } from "./constants/constants";

export const getCurrentGame = () => {
  const currentGame = localStorage.getItem(CURRENT_GAME_KEY);
  if (currentGame && currentGame in DEFAULT_GAMES) {
    return currentGame;
  }
  return "default";
};

export const noop = (...params: any) => {
  alert(`Did not expect to run this method. Parameters: ${params}`);
};
